<template>
    <div>
        <el-container class="container" direction="vertical">
            <el-row>
                <el-row>
                    <div style="font-size: 32;font-weight: bolder;">既往病史</div>
                </el-row>
                <el-row style="background-color: #d5d5d5;height: 0.5px;width: 100%;margin-top: 20px;" />

            </el-row>

            <el-row style="margin-top: 30px;">
                <div>
                    <el-descriptions direction="vertical" :column="1" size="mini" :colon="false">
                        <el-descriptions-item :span="4" label="*药物过敏史">
                            <el-checkbox-group style="display: flex;margin-bottom: 10px;" @change="allergyDataChange"
                                v-model="allergyDrugArr">
                                <el-checkbox v-for="item in allergyData" :value="item.value" :label="item.value"
                                    :key="item.value">{{ item.name }}</el-checkbox>
                            </el-checkbox-group>
                        </el-descriptions-item>

                        <el-descriptions-item :span="4" label="*暴露史">
                            <el-checkbox-group style="display: flex;margin-bottom: 10px;" @change="envRiskChange"
                                v-model="envRiskArr">
                                <el-checkbox v-for="item in envRiskData" :label="item.value" :value="item.value"
                                    :key="item.value">{{ item.name }}</el-checkbox>
                            </el-checkbox-group>
                        </el-descriptions-item>

                        <el-descriptions-item contentClassName="deseasesClass" :span="4" label="*疾病史">
                            <el-form size="small" :inline="true" v-for="(item, index) in diseases" :key="index">
                                <el-form-item label="疾病名称">
                                    <el-select v-model="item.diseaseCode" placeholder="疾病名称">
                                        <el-option v-for="(option, index) in diseasesData" :key="index"
                                            :label="option.name" :value="option.value"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="确诊时间">
                                    <el-date-picker v-model="item.diseaseTime" placeholder=""
                                        value-format="yyyy-MM-dd"></el-date-picker>
                                </el-form-item>
                            </el-form>
                        </el-descriptions-item>

                        <el-descriptions-item contentClassName="deseasesClass" :span="4" label="*家族史">
                            <el-form size="small" :inline="true" v-for="(item, index) in familyHistory" :key="index">
                                <el-form-item label="疾病名称">
                                    <el-select v-model="item.diseaseCode" placeholder="疾病名称">
                                        <el-option v-for="(option, index) in diseasesData" :key="index"
                                            :label="option.name" :value="option.value"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="家族关系">
                                    <el-select v-model="item.familyRelationCode" placeholder="关系">
                                        <el-option v-for="(item, index) in familyRelationData" :key="index"
                                            :label="item.name" :value="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-form>
                        </el-descriptions-item>

                        <el-descriptions-item contentClassName="deseasesClass" :span="4" label="手术史">
                            <el-form size="small" :inline="true" v-for="(item, index) in surgerys" :key="index">
                                <el-form-item label="手术名称">
                                    <el-input v-model="item.surgeryName" placeholder="手术名称"></el-input>
                                </el-form-item>
                                <el-form-item label="确诊时间">
                                    <el-date-picker v-model="item.surgeryTime" placeholder=""
                                        value-format="yyyy-MM-dd"></el-date-picker>
                                </el-form-item>
                            </el-form>
                        </el-descriptions-item>

                        <el-descriptions-item contentClassName="deseasesClass" :span="4" label="外伤史">
                            <el-form size="small" :inline="true" v-for="(item, index) in wounds" :key="index">
                                <el-form-item label="外伤名称">
                                    <el-input v-model="item.woundName" placeholder="名称"></el-input>
                                </el-form-item>
                                <el-form-item label="确诊时间">
                                    <el-date-picker v-model="item.woundTime" placeholder=""
                                        value-format="yyyy-MM-dd"></el-date-picker>
                                </el-form-item>
                            </el-form>
                        </el-descriptions-item>

                        <el-descriptions-item contentClassName="deseasesClass" :span="4" label="输血史">
                            <el-form size="small" :inline="true" v-for="(item, index) in bloodTransHistory"
                                :key="index">
                                <el-form-item label="输血原因">
                                    <el-input v-model="item.bloodtransReason" placeholder="原因"></el-input>
                                </el-form-item>
                                <el-form-item label="输血时间">
                                    <el-date-picker v-model="item.bloodtransTime" placeholder=""
                                        value-format="yyyy-MM-dd"></el-date-picker>
                                </el-form-item>
                            </el-form>
                        </el-descriptions-item>
                    </el-descriptions>
                </div>

            </el-row>

        </el-container>
    </div>
</template>
<script>

import {
    getlistEhrDepts,
    updatePatientList,
    getAreaList,
    getSysDicList
} from "@/api/health/Patients";
import { addPatientEasyillDiabetsModel } from "@/api/health/EhrQuery";

export default {
    components: {},
    props: {
        pInfo: null,
    },
    data() {
        return {
            activeName: "first",
            treeData: [],
            sexOptions: [],
            statusOptions: [],
            residFlagList: [],
            nationList: [],
            payWayData: [],
            bloodTypeData: [],
            RHData: [],
            educationData: [],
            diseasesData: [],
            familyRelationData: [],
            vocationData: [],
            allergyData: [],
            envRiskData: [],
            allergyDrugArr: ['1'],
            envRiskArr: ['1'],
            baseFormData: null,
            provinceData: [],
            cityData: [],
            countyData: [],
            townData: [],
            villageData: [],
            //疾病史
            diseases: [{
                diseaseCode: null,
                diseaseName: null,
                diseaseTime: null
            }],
            //手术史
            surgerys: [{
                surgeryName: null,
                surgeryTime: null
            }],
            //外伤史
            wounds: [{
                woundName: null,
                woundTime: null
            }],
            //输血史
            bloodTransHistory: [{
                bloodtransReason: null,
                bloodtransTime: null
            }],
            //家族史
            familyHistory: [{
                diseaseCode: null,
                diseaseName: null,
                diseaseTime: null,
                familyRelationCode: null,
                familyRelationName: null
            }],
        }
    },
    created() {
        console.log("基础信息");
        var typeData = "性别,民族,血型代码表,RH血型代码表,学历,职业,档案状态,户籍标志,医疗费用来源类别代码表,既往常见疾病种类代码表,公卫药物过敏史,公卫暴露史,家庭关系代码";
        this.getSystemDictList(typeData);

        this.getProvinceData();
        this.initData(this.pInfo);
    },
    methods: {
        initData(value) {
            this.diseases = value.diseases ? value.diseases : [{
                diseaseCode: null,
                diseaseName: null,
                diseaseTime: null
            }];
            this.surgerys = value.surgerys && value.surgerys.length > 0  ? value.surgerys : [{
                surgeryName: null,
                surgeryTime: null
            }];
            this.wounds = value.wounds && value.wounds.length > 0  ? value.wounds : [{
                woundName: null,
                woundTime: null
            }];
            this.bloodTransHistory = value.bloodTransHistory && value.bloodTransHistory.length > 0  ? value.bloodTransHistory : [{
                bloodtransReason: null,
                bloodtransTime: null
            }];
            this.familyHistory = value.familyHistory ? value.familyHistory : [{
                diseaseCode: null,
                diseaseName: null,
                diseaseTime: null,
                familyRelationCode: null,
                familyRelationName: null
            }];
            this.allergyDrugArr = value.allergyDrug ? value.allergyDrug.split("，") : [];
            this.envRiskArr = value.envRisk ? value.envRisk.split("，") : [];
            this.baseFormData = {
                id: value.id,
                healthNo: value.healthNo ? value.healthNo : null,
                name: value.name ? value.name : null,
                gender: value.gender ? value.gender : null,
                status: value.status ? value.status : null,
                birthday: value.birthday ? value.birthday : null,
                idcardType: value.idcardType ? value.idcardType : null,
                idcard: value.idcard ? value.idcard : null,
                workDept: value.workDept ? value.workDept : null,
                phone: value.phone ? value.phone : null,
                contactName: value.contactName ? value.contactName : null,
                contactPhone: value.contactPhone ? value.contactPhone : null,
                residFlag: value.residFlag ? value.residFlag : null,
                nation: value.nation ? value.nation : null,
                bloodType: value.bloodType ? value.bloodType : null,
                bloodRh: value.bloodRh ? value.bloodRh : null,
                edu: value.edu ? value.edu : null,
                vocation: value.vocation ? value.vocation : null,
                marriage: value.marriage ? value.marriage : null,
                payWay: value.payWay ? value.payWay : null,
                isDiabetStdManage: value.isDiabetStdManage ? value.isDiabetStdManage : null,
                allergyDrug: value.healthNo ? value.healthNo : null,
                envRisk: value.envRisk ? value.envRisk : null,
                geneticDiseaseHistory: value.geneticDiseaseHistory ? value.geneticDiseaseHistory : null,
                kitchenExhaustCode: value.kitchenExhaustCode ? value.kitchenExhaustCode : null,
                managerHospital: value.managerHospital ? value.managerHospital : null,
                province: value.province ? value.province : null,
                city: value.city ? value.city : null,
                county: value.county ? value.county : null,
                town: value.town ? value.town : null,
                village: value.village ? value.village : null,
                provinceCode: value.provinceCode ? value.provinceCode : null,
                cityCode: value.cityCode ? value.cityCode : null,
                countyCode: value.countyCode ? value.countyCode : null,
                townCode: value.townCode ? value.townCode : null,
                villageCode: value.villageCode ? value.villageCode : null,
                houseNumber: value.houseNumber ? value.houseNumber : null,
                creator: 'web',
                diseases: value.diseases ? value.diseases : [{
                    diseaseCode: null,
                    diseaseName: null,
                    diseaseTime: null
                }],
                surgerys: value.surgerys && value.surgerys.length > 0 ? value.surgerys : [{
                    surgeryName: null,
                    surgeryTime: null
                }],
                wounds: value.wounds && value.wounds.length > 0 ? value.wounds : [{
                    woundName: null,
                    woundTime: null
                }],
                bloodTransHistory: value.bloodTransHistory && value.bloodTransHistory.length > 0 ? value.bloodTransHistory : [{
                    bloodtransReason: null,
                    bloodtransTime: null
                }],
                familyHistory: value.familyHistory ? value.familyHistory : [{
                    diseaseCode: null,
                    diseaseName: null,
                    diseaseTime: null,
                    familyRelationCode: null,
                    familyRelationName: null
                }],
                deformity: value.deformity ? value.deformity : null,
            }
            this.getAreaData(value.provinceCode, "city");
            this.getAreaData(value.cityCode, "country")
            this.getAreaData(value.countyCode, "town")
            this.getAreaData(value.townCode, "village")

            console.log("this.baseFormData:", this.baseFormData);
        },
        getOptionvalue(type, value) {
            if (type == "gender") {
                var option = this.sexOptions.filter(v => v.value == value)[0];
                return option.name;
            }
            if (type == "nation") {
                var option = this.nationList.filter(v => v.value == value)[0];
                return option.name;
            }
            if (type == "bloodType") {
                var option = this.bloodTypeData.filter(v => v.value == value)[0];
                return option.name;
            }
            if (type == "bloodRh") {
                var option = this.RHData.filter(v => v.value == value)[0];
                return option.name;
            }
            if (type == "edu") {
                var option = this.educationData.filter(v => v.value == value)[0];
                return option.name;
            }
            if (type == "vocation") {
                var option = this.vocationData.filter(v => v.value == value)[0];
                return option.name;
            }
            if (type == "payWay") {
                var option = this.payWayData.filter(v => v.value == value)[0];
                return option.name;
            }
            if (type == "status") {
                var option = this.statusOptions.filter(v => v.value == value)[0];
                return option.name;
            }
            if (type == "residFlag") {
                var option = this.residFlagList.filter(v => v.value == value)[0];
                return option.name;
            }
        },
        getSystemDictList(typeName) {
            var typeData = {
                "typeName": typeName
            };
            getSysDicList(typeData).then(res => {
                var records = [];
                if (res.msg == "success") {
                    var data = res.data;
                    records = data.records;
                }
                this.sexOptions = records.filter(item => {
                    return item.typeName == "性别";
                })
                this.nationList = records.filter(item => {
                    return item.typeName == "民族";
                })
                this.bloodTypeData = records.filter(item => {
                    return item.typeName == "血型代码表";
                })
                this.RHData = records.filter(item => {
                    return item.typeName == "RH血型代码表";
                })
                this.educationData = records.filter(item => {
                    return item.typeName == "学历";
                })
                this.vocationData = records.filter(item => {
                    return item.typeName == "职业";
                })
                this.payWayData = records.filter(item => {
                    return item.typeName == "医疗费用来源类别代码表";
                })
                this.diseasesData = records.filter(item => {
                    return item.typeName == "既往常见疾病种类代码表";
                })
                this.allergyData = records.filter(item => {
                    return item.typeName == "公卫药物过敏史";
                })
                this.envRiskData = records.filter(item => {
                    return item.typeName == "公卫暴露史";
                })
                this.familyRelationData = records.filter(item => {
                    return item.typeName == "家庭关系代码";
                })
                this.statusOptions = records.filter(item => {
                    return item.typeName == "档案状态";
                })
                this.residFlagList = records.filter(item => {
                    return item.typeName == "户籍标志";
                })
            }).catch(err => {
                console.log(err);
            })
        },
        setDialogClosed() {
            this.showDialog = false;
        },
        getProvinceData() {
            var arr = [];
            getAreaList({ level: 1, page: 1, pageSize: 100 }).then(res => {
                if (res.msg == "success") {
                    var data = res.data;
                    var records = data.records;
                    records.map((item, index) => {
                        arr.push(
                            Object.assign({
                                value: item.code,
                                label: item.name
                            })
                        )
                    })
                    this.provinceData = arr;
                    this.baseFormData.provinceCode = 370000000000;
                    this.getAreaData(this.baseFormData.provinceCode, 'city');

                    this.baseFormData.cityCode = 370200000000;
                    this.getAreaData(this.baseFormData.cityCode, 'country');

                    this.baseFormData.countyCode = 370211000000;
                    this.getAreaData(this.baseFormData.countyCode, 'town');
                } else {

                }
            }).catch(err => {
                console.log(err);
            })
        },
        allergyDataChange(e) {
            // console.log("过敏史选择：",e);
            if (e.at(-1) == "1") {
                //当前选项“无”
                this.allergyDrugArr = ['1'];
            } else {
                if (this.allergyDrugArr.indexOf("1") != -1) {
                    this.allergyDrugArr.splice(this.allergyDrugArr.indexOf('1'), 1)
                }
            }
        },
        envRiskChange(e) {
            if (e.at(-1) == "1") {
                this.envRiskArr = ['1'];
            } else {
                if (this.envRiskArr.indexOf("1") != -1) {
                    this.envRiskArr.splice(this.envRiskArr.indexOf('1'), 1)
                }
            }
        },
        getAreaData(parentcode, type) {
            var arr = [];
            var params = {
                pcode: parentcode
            }
            getAreaList(params).then(res => {
                if (res.msg == "success") {
                    var data = res.data;
                    var records = data.records;
                    records.map((item, index) => {
                        arr.push(
                            Object.assign({
                                value: item.code,
                                label: item.name
                            })
                        )
                    })
                    if (type == "city") {
                        this.cityData = arr;
                    }
                    if (type == "country") {
                        this.countyData = arr;
                    }
                    if (type == "town") {
                        this.townData = arr;
                    }
                    if (type == "village") {
                        this.villageData = arr;
                    }
                } else { }
            }).catch(err => {
                console.log(err);
            })
        },
        provinceCodeChange(e) {
            console.log(e)
            this.getAreaData(e, 'city');

            this.baseFormData.cityCode = null;
            this.baseFormData.countyCode = null;
            this.baseFormData.townCode = null;
            this.baseFormData.villageCode = null;
        },
        cityCodeChange(e) {
            this.getAreaData(e, 'country');

            this.baseFormData.countyCode = null;
            this.baseFormData.townCode = null;
            this.baseFormData.villageCode = null;
        },
        countyCodeChange(e) {
            this.getAreaData(e, 'town');

            this.baseFormData.townCode = null;
            this.baseFormData.villageCode = null;
        },
        townCodeChange(e) {
            this.getAreaData(e, 'village');

            this.baseFormData.villageCode = null;
        },
        villageCodeChange(e) {

        },
        // 机构返显
        orgInput(value) {
            // console.log("机构返显", value, value[0]);
            this.baseFormData.managerHospital = value[0];
        },
        // 计算年龄
        getAge(birthday) {
            if (birthday == null) return "";

            var birthdays = new Date(birthday.replace(/-/g, "/"));
            let d = new Date();
            let age =
                d.getFullYear() -
                birthdays.getFullYear() -
                (d.getMonth() < birthdays.getMonth() ||
                    (d.getMonth() == birthdays.getMonth() &&
                        d.getDate() < birthdays.getDate())
                    ? 1
                    : 0);
            return age;
        }
    }
}
</script>
<style lang="scss" scoped>
::v-deep {
    .el-dialog {
        margin-top: 5vh !important;
    }

    .el-descriptions-item__label.is-bordered-label {
        width: 120px !important;
    }

    .el-checkbox-group {
        width: 100px;
    }

    .el-input {
        width: 200px;
    }
}

.el-tabs--card .el-tabs__content {
    overflow-y: auto;
    padding: 10px;
}
</style>